import React from 'react';

function PropsView() {
  return (
    <div className="props-view">
      <div className="container">
        <h2>Player Props</h2>
        <p>Analyze player prop bets</p>
      </div>
    </div>
  );
}

export default PropsView;
